import React from 'react';

import { ReactComponent as TrashBinIcon } from '@pkg/components/Sections/Profile/icons/trash-bin.svg';
import { useAppDispatch } from '@pkg/hooks';
import { useMediaQuery } from '@pkg/providers';

import { removeItem } from '@app/store/actions/yat-page-item-actions';
import { type ContentItem } from '@app/store/types/yat-page-actions';

import { DRAGGABLE_CLASS_NAME_TO_IGNORE } from '../../DraggableMasonry';

import { StyledYatButton } from './styles';

interface Props {
    className?: string;
    canShow?: boolean;
    item: ContentItem;
}

export const RemoveButton = ({ className, canShow = true, item }: Props) => {
    const { desktop } = useMediaQuery();
    const dispatch = useAppDispatch();

    /**
     * As a parent component (YatDraggableMasonry) is using onMouseDown for dragging.
     */
    const handleOnMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        dispatch(removeItem(item.id));
    };

    if (!desktop) return null;

    return (
        <StyledYatButton
            className={`${className} ${DRAGGABLE_CLASS_NAME_TO_IGNORE}`}
            variant="solid"
            color="secondary"
            size="extraSmall"
            onMouseDown={handleOnMouseDown}
            $canShow={canShow}
        >
            <TrashBinIcon className={DRAGGABLE_CLASS_NAME_TO_IGNORE} />
        </StyledYatButton>
    );
};
